<template>
    <div class="layout-sidebar">
        <div class="sidebar">
            <ul class="sidebar-menu">
                <li v-for="item in sideberMap" :key="item.name">
                    <!-- <router-link :to="{name: item.name}" :class="[item.className, item.name === activeName?'active':'']">
                        <i></i>
                        {{ item.text }}
                        <i v-if="item.text === '历史课程' && unCorrectList.length ||
                        item.text === '作业中心' && unCorrectList.length" class="red-point"></i>
                    </router-link> -->
                    <router-link :to="{name: item.name}" :class="[item.className, item.img === activeName?'active':'']">
                        <!-- <i></i> -->
                        <div v-if="item.text !== '测评与考试'" style="text-align: center">
                            <img :src="item.img === activeName? item.selected : item.url"/>
                            <div>
                                {{ item.text }}
                                <i v-if="item.text === '历史课程' && unCorrectList.length || item.text === '作业中心' && unCorrectList.length || item.text === '胶囊测评' && capsuleCount" class="red-point"></i>
                            </div>
                        </div>
                        <div v-else style="text-align: center">
                            <el-dropdown placement="right">
                                <div style="color: #ccc; font-size: 14px; font-family: inherit">
                                    <img :src="item.img === activeName? item.selected : item.url"/>
                                    <div>
                                        {{ item.text }}
                                        <i v-if="item.text === '测评与考试' && capsuleCount" class="red-point"></i>
                                    </div>
                                    <el-badge :value="totalCount" :hidden="!totalCount" :max="99" class="header-nav-mark header-nav-mark2" />
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <div @click="$router.push({name: 'evaluation@capsule'})" @mouseover="jnHover = true" @mouseout="jnHover = false">
                                            <img class="img-align" v-show="!jnHover" src="@/assets/images/evaluation/kscp_icon_jncp_default.png">
                                            <img class="img-align" v-show="jnHover" src="@/assets/images/evaluation/kscp_icon_jncp.png">
                                            <span>胶囊测评</span>
                                            <el-badge :value="capsuleCount" :hidden="!capsuleCount" :max="99" class="header-nav-mark header-nav-mark1" />
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item divided>
                                        <div @click="$router.push({name: 'evaluation@course'})" @mouseover="ksHover = true" @mouseout="ksHover = false">
                                            <img class="img-align" v-show="!ksHover" src="@/assets/images/evaluation/kscp_icon_kscp_default.png">
                                            <img class="img-align" v-show="ksHover" src="@/assets/images/evaluation/kscp_icon_kscp.png">
                                            <span :class="$route.name === 'evaluation@course' ? 'item-active' : ''">考试测评</span>
                                            <el-badge :value="evaluationCount" :hidden="!evaluationCount" :max="99" class="header-nav-mark header-nav-mark1" />
                                        </div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </router-link>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import schedule from '../../../assets/images/common/dh_icon_kb_default.png';
import scheduleSelected from '../../../assets/images/common/dh_icon_kb_pressed.png';
import student from '../../../assets/images/common/dh_icon_xs_default.png';
import studentSelected from '../../../assets/images/common/dh_icon_xs_pressed.png';
import history from '../../../assets/images/common/dh_icon_kc_default.png';
import historySelected from '../../../assets/images/common/dh_icon_kc_pressed.png';
import setting from '../../../assets/images/common/dh_icon_sz_default.png';
import settingSelected from '../../../assets/images/common/dh_icon_sz_pressed.png';
import homework from '../../../assets/images/common/dh_icon_zy_default.png';
import homeworkSelected from '../../../assets/images/common/dh_icon_zy_pressed.png';
import evaluation from '../../../assets/images/common/dh_icon_cp_default.png';
import evaluationSelected from '../../../assets/images/common/dh_icon_cp_pressed.png';
import Vue from 'vue';
const SIDEBAR_MAP = [
                {
                    url: schedule,
                    selected: scheduleSelected,
                    name: 'schedule@course',
                    img: 'schedule@course',
                    text: '我的课表',
                    className: 'sidebar-schedule'
                },
                {
                    url: student,
                    selected: studentSelected,
                    name: 'student@course',
                    img: 'student@course',
                    text: '我的学生',
                    className: 'sidebar-student'
                },
                {
                    url: history,
                    selected: historySelected,
                    name: 'history@course',
                    img: 'history@course',
                    text: '历史课程',
                    className: 'sidebar-history'
                },
                {
                    url: setting,
                    selected: settingSelected,
                    name: 'setting@course',
                    img: 'setting@course',
                    text: '时间管理',
                    className: 'sidebar-setting'
                },
                {
                    url: homework,
                    selected: homeworkSelected,
                    name: 'homework@course',
                    img: 'homework@course',
                    text: '作业中心',
                    className: 'sidebar-homework'
                },
                {
                    url: evaluation,
                    selected: evaluationSelected,
                    name: '',
                    img: 'evaluation@course',
                    text: '测评与考试',
                    className: 'sidebar-evaluation'
                }
            ];
export default {
    data() {
        return {
            unCorrectList: [], // 作业中心、历史课程不为空时显示小红点
            evaluationList: [], // 测评与考试列表存在‘推送测评‘ ’待批改‘时显示小红点
            jnHover: false,
            ksHover: false
        };
    },
    computed: {
        ...mapState({
            redDots: state => state.user.redDots
        }),
        ...mapGetters(['isShowOldEva']),
        totalCount() {
            return (this.redDots.pendingPushEvaluationCount + this.redDots.uncheckedEvaluationCount + this.redDots.capsuleEvaluationCount) || 0;
        },
        evaluationCount() {
            return (this.redDots.pendingPushEvaluationCount + this.redDots.uncheckedEvaluationCount) || 0;
        },
        capsuleCount() {
            return this.redDots.capsuleEvaluationCount || 0;
        },
        // 高亮侧边栏name
        activeName() {
            let name = this.$route.name;
            let targetName = '';
            if (name) {
                if (name.indexOf('schedule@') > -1) {
                    targetName = 'schedule@course';
                } else if (name.indexOf('student') > -1) {
                    targetName = 'student@course';
                } else if (name.indexOf('history@') > -1) {
                    targetName = 'history@course';
                } else if (name.indexOf('setting@') > -1) {
                    targetName = 'setting@course';
                } else if (name.indexOf('homework@') > -1) {
                    targetName = 'homework@course';
                } else if (name.indexOf('evaluation@') > -1) {
                    targetName = 'evaluation@course';
                }
            }
            return targetName;
        },
        // 导航数据
        sideberMap() {
            if (!this.isShowOldEva) {
                SIDEBAR_MAP[5] = {
                    url: evaluation,
                    selected: evaluationSelected,
                    name: 'evaluation@capsule',
                    img: 'evaluation@course',
                    text: '胶囊测评',
                    className: 'sidebar-evaluation'
                };
                return SIDEBAR_MAP;
            }
            return SIDEBAR_MAP;
        }
    },
    beforeMount() {
        this.getHomeworkList();
        this.getEvaluation();
    },
    methods: {
        getHomeworkList() {
            Vue.http.get('/v1/homework/list', { params: {
                studentUsername: '',
                homeworkStatus: '',
                start: 0,
                limit: 10
            } })
                .then(resp => this.$checkResp(resp, {}))
                .then(data => {
                    data.homework && data.homework.forEach((item, index) => {
                        if (item.hwStatus === 2) {
                            this.unCorrectList.push(index);
                        }
                    });
                });
        },
        /**
             * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=357915930#hfsfd-teacher%E9%98%B6%E6%AE%B5%E6%B5%8B%E8%AF%84API-%E8%8E%B7%E5%8F%96%E9%98%B6%E6%AE%B5%E6%B5%8B%E8%AF%84%E5%88%97%E8%A1%A8
             *
             */
        // 获取测评列表接口
        getEvaluation() {
            let param = {
                start: 0,
                limit: 10,
                status: 'pending_push'
            };
            this.$http
                .get('/v1/stage-evaluation/list', {param})
                .then(resp => Vue.checkResp(resp, {}))
                .then(data => {
                    data.list.forEach((item, index) => {
                        if (item.status === 'pending_push') {
                            this.evaluationList.push(index);
                        }
                    });
                })
                .catch(error => {
                    throw error;
                })
                .finally(() => {
                });
            let params = {
                start: 0,
                limit: 10,
                status: 'unchecked'
            };
            this.$http
                .get('/v1/stage-evaluation/list', {params})
                .then(resp => Vue.checkResp(resp, {}))
                .then(data => {
                    data.list.forEach((item, index) => {
                        if (item.status === 'unchecked') {
                            this.evaluationList.push(index);
                        }
                    });
                })
                .catch(error => {
                    this.handleError();
                    this.noData = true;
                    throw error;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.sidebar {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-sizing: border-box;
    overflow-y: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
}

.sidebar-menu {
    a {
        display: flex;
        height: 90px;
        justify-content: center;
        align-items: center;
        color: #cccccc;
        flex-direction: column;
        // padding-left: 44px;
        text-decoration: none;

        img {
            width: 22px;
            margin-bottom: 10px;
        }

        div {
            position: relative;
            // margin-top: 10px;

            i {
                position: absolute;
                right: -15px;
                top: 0;
            }
        }

        &:hover {
            background-color: #fafafa;
        }

        &.active {
            text-decoration: none;
            color: #F4664B;
            background-image: url('../../../assets/images/common/dh_icon_tiao.png');
            background-repeat: no-repeat;
            background-position: 0 center;
            background-size: 6px;
        }

        &.sidebar-schedule {
            i {
                background: url(../../../assets/images/common/nav_schedule_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_schedule_selected.png) no-repeat;
                background-size: contain;
            }
        }

        &.sidebar-student {
            i {
                background: url(../../../assets/images/common/nav_student_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_student_selected.png) no-repeat;
                background-size: contain;
            }
        }

        &.sidebar-history {
            i {
                background: url(../../../assets/images/common/nav_history_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_history_selected.png) no-repeat;
                background-size: contain;
            }
        }

        &.sidebar-setting {
            i {
                background: url(../../../assets/images/common/nav_setting_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_setting_selected.png) no-repeat;
                background-size: contain;
            }
        }

        &.sidebar-homework {
            i {
                background: url(../../../assets/images/common/nav_work_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_work_selected.png) no-repeat;
                background-size: contain;
            }
        }

        &.sidebar-evaluation {
            i {
                background: url(../../../assets/images/common/nav_work_default.png) no-repeat;
                background-size: contain;
            }

            &:hover i,
            &.active i {
                background: url(../../../assets/images/common/nav_work_selected.png) no-repeat;
                background-size: contain;
            }
        }

        .red-point {
            width: 8px;
            height: 8px;
            background-color: #f4664b !important;
            background-image: none !important;
            margin-left: 5px;
            margin-right: 0;
            border-radius: 50%;
        }
    }
}

.sidebar-service {
    position: absolute;
    left: 20px;
    bottom: 20px;
    width: 160px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #4abef9;
    color: #fff;
    font-size: 14px;
    cursor: pointer;

    &:hover {
        background-color: lighten(#4abef9, 3%);
    }

    i {
        vertical-align: middle;
        margin-right: 5px;
        font-size: 20px;
    }
}
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}

.img-align {
    vertical-align: sub;
}

.item-active {
    color: #1daef8;
}

.header-nav-mark {
    position: absolute;
    top: -10px;
    left: 68px;

    /deep/ .el-badge__content {
        height: 12px;
        line-height: 12px;
        padding: 0 3px;
        font-size: 8px;
        border: none;
        background-color: #F4664B;
    }
}

.header-nav-mark1 {
    top: -6px;
    left: 98px;
}

.header-nav-mark2 {
    top: -70px;
    left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/AppSidebar.vue